import React from 'react';
import block from 'bem-cn';
// import PT from 'prop-types';
import Spinner from 'components/Spinner';
import { useSelector } from 'react-redux';

import BackBlock from 'components/BackBlock';

import useBithidePayment from 'features/payment/model/bithidePayment/useBithidePayment';

import BithidePaymentMain from './BithidePaymentMain';
import BithidePaymentPay from './BithidePaymentPay';

import './BithidePayment.scss';

const b = block('bithide-payment');

const BithidePayment = () => {
  const { locale } = useSelector(state => state.locale);
  const { actionProcessing } = useSelector(state => state.payment);

  const {
    onCancelClick,
    onDepositInit,
    onPaidClick,
    onUsdtAmountChange,
    values: {
      step,
      tndAmount,
      usdtAmount,
    }
  } = useBithidePayment();

  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} />
      <BackBlock />
      <h1 className={b('title')}>{locale.payment}</h1>
      {step === 1 && (
        <BithidePaymentMain
          tndAmount={tndAmount}
          usdtAmount={usdtAmount}
          onUsdtAmountChange={onUsdtAmountChange}
          onDepositInit={onDepositInit}
        />
      )}
      {step === 2 && (
        <BithidePaymentPay
          onCancelClick={onCancelClick}
          onPaidClick={onPaidClick}
        />
      )}  
    </div>
  );
};

BithidePayment.propTypes = {};

export default BithidePayment;
